import { CityProxy } from './city-proxy.model';

export class CitiesResponse {
  cities: CityProxy[];
}
